export interface ItemInstance {
  expiryDate: string | null;
  batchNumber?: string;
  serialNumber?: string;
  condition?: string;
  notes?: string;
}

export interface CompartmentItem {
  itemId: string;
  name: string;
  qty: number;
  instances?: ItemInstance[];
  nextExpiry?: string | null; // Computed by backend
}

export interface CompartmentContents {
  items: CompartmentItem[];
  modulePacks?: ModulePack[];
}

export interface ModulePack {
  name: string;
  items: CompartmentItem[];
}

export interface Compartment {
  id: string;
  itemId: string;
  name: string;
  position: number;
  contents: CompartmentContents;
  createdAt: string;
  updatedAt: string;
}

/**
 * Formats a date string (YYYY-MM-DD) to a localized format
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  });
}

/**
 * Checks if a date is within the specified number of days from today
 */
export function isWithinDays(dateString: string, days: number): boolean {
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  const diffTime = date.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays >= 0 && diffDays <= days;
}

/**
 * Checks if a date is in the past
 */
export function isPast(dateString: string): boolean {
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date < today;
}

/**
 * Initializes instances array with null expiry dates
 */
export function initializeInstances(qty: number, existingInstances?: ItemInstance[]): ItemInstance[] {
  if (existingInstances && existingInstances.length === qty) {
    return existingInstances;
  }
  return Array(qty).fill(null).map(() => ({ expiryDate: null }));
}
